










































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  groupTrendBMIDistribute,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import BarDashedLine from '../../_components/charts/BarDashedLine.vue'
import BarDashed from '../../_components/charts/BarDashed.vue'

@Component({
  components: {
    BasePanel,
    BarDashedLine,
    BarDashed
  }
})
export default class extends Vue {
  private dataLength: number = 0;
  private frirstChartData: any = {};
  private barDataArray: Array<object> = [];
  private colorList: any = ['#3A91FF', '#6DD400', '#FFA100', '#A35DFF'];
  private classroomName: any = '';
  private sexName: any = '';
  private compareName: any = '';
  private tabPosition: any = '';
  private classNames: any = [];
  private params: any = {};
  private chartShow: any = true;
  created() {
    if (!this.$route.query.searchParams) return
    this.params = JSON.parse(this.$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(this.params))
    const params = JSON.parse(
      (this as any).$route.query.searchParams as string
    )
    const classroomNames: any = []
    const sexNames: any = []
    const compareNames: any = []

    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (this.params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (this.params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    this.$enums.classroomTypes.map((v: any) => {
      if (this.params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
        this.classNames.push({
          name: v.description,
          code: v.code
        })
      }
    })
    this.compareName = compareNames.join('、')
    if (!(this.params.classroomIds.length > 0)) {
      // console.info(Math.min(this.params.compareIds))
      // this.params.compareIds = [Math.min(this.params.compareIds)]
      this.tabPosition = this.classNames[0].code
    }
    groupTrendBMIDistribute(this.params).then((res) => {
      if (res.data.bmidistribute) {
        this.dataLength = res.data.bmidistribute.details.length
        this.frirstChartData = res.data.bmidistribute
      }
      this.barDataArray = res.data.barChart || []
    })
  }
  tabChange(tab: any) {
    this.params.compareIds = [tab]
    groupTrendBMIDistribute(this.params).then((res) => {
      if (res.data.bmidistribute) {
        this.dataLength = res.data.bmidistribute.details.length
        this.frirstChartData = res.data.bmidistribute
      }
      this.barDataArray = res.data.barChart || []
    })
  }
}
